import { styled } from "goober";
import { type ReactNode, useRef, useState } from "react";
import { writeToClipboard } from "../../lib/writeToClipboard";
import { ClickButton } from "../ClickButton";
import { AnimatedCopyIcon } from "../AnimatedCopyIcon";

const Root = styled(ClickButton)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 0.5px solid var(--border-alpha);
  background: var(--alpha2);
  word-break: break-all;

  &:hover {
    background: var(--alpha4);
  }
`;

const IconWrap = styled("span")`
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
  color: var(--text-secondary);
`;

export function CopyableValue({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  return (
    <Root
      data-no-pill
      onClick={() => {
        void writeToClipboard(value);
        setCopied(true);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setCopied(false), 1500);
      }}
      title="Click to copy"
    >
      {children}
      <IconWrap>
        <AnimatedCopyIcon copied={copied} />
      </IconWrap>
    </Root>
  );
}
